module.exports = __webpack_public_path__ + "static/Cumple30Exsis2x-9eca466a94589d8b7cabe9a3abaa3623.png";